<template>
    <v-card class="work-card">
        <v-card-title class="primary white--text">
            {{ selectedWork.Descricao }}
        </v-card-title>

        <v-card-title class="ma-0 pa-0">
            <v-tabs v-model="tabs" background-color="warning" dark fixed-tabs>
                <v-tab>Adicionar colaboradores</v-tab>
                <v-tab>Localização</v-tab>
                <v-tab v-if="isSuper">Definições</v-tab>
            </v-tabs>
        </v-card-title>

        <v-progress-linear
            v-if="loading"
            class="mb-8"
            color="primary"
            indeterminate
        ></v-progress-linear>

        <v-tabs-items v-model="tabs">
            <v-tab-item>
                <v-card-text class="mt-6" v-if="loading == false">
                    <v-row>
                        <v-col cols="12" md="8">
                            <v-autocomplete
                                :items="arrayWorkers"
                                :item-text="item => item.funcionario_codigo + ' - ' + item.name"
                                v-model="selectedWorker"
                                label="Utilizadores"
                                dense
                                outlined
                                item-value="id"
                            />
                        </v-col>

                        <v-col cols="12" md="4">
                            <v-btn class="success" @click="addUsersToWork" block>
                                Adicionar Colaborador
                            </v-btn>
                        </v-col>

                        <v-col cols="12" md="8" v-if="false">
                            <v-autocomplete
                                label="Equipa"
                                :items="teams"
                                v-model="choosenTeam"
                                dense
                                outlined
                                item-value="id"
                                item-text="name"
                            />
                        </v-col>

                        <v-col cols="12" md="4" v-if="false">
                            <v-btn class="success" @click="addUsersFromTeam" block>
                                Adicionar de equipa
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">Código</th>
                                            <th class="text-left">Nome</th>
                                            <th class="text-left">Role</th>
                                            <th class="text-left">Opção</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="item in workersInWork"
                                            :key="item.id"
                                        >
                                            <td>{{ item.funcionario_codigo }}</td>
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.roles }}</td>
                                            <td>
                                                <IconRemove
                                                    class="mr-2"
                                                    @on-submit="deleteUser(item)"
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-tab-item>

            <v-tab-item>
                <Localization :id="selectedWork.Id" />
            </v-tab-item>

            <v-tab-item v-if="isSuper">
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-card outlined class="mb-3">
                                <v-card-title>Integrações</v-card-title>
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead><tr><th>Função</th><th class="text-center">Opção</th></tr></thead>
                                        <tbody>
                                            <tr>
                                                <td>Ativar integração da obra para o Primavera</td>
                                                <td class="text-center">
                                                    <v-switch v-model="primaveraIntegrationEnabled"
                                                        color="success" inset hide-details class="d-inline-flex mt-0"
                                                        :loading="primaveraIntegrationSaving"
                                                        :disabled="primaveraIntegrationSaving || primaveraIntegrationLoading"
                                                        @change="togglePrimaveraIntegration" />
                                                    <span class="ml-2">{{ primaveraIntegrationEnabled ? 'Sim' : 'Não' }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Integração manual via ODC</td>
                                                <td class="text-center">
                                                    <v-switch v-model="manualIntegrationEnabled"
                                                        inset color="success" hide-details class="d-inline-flex mt-0"
                                                        :loading="manualIntegrationSaving"
                                                        :disabled="manualIntegrationSaving || !isSuper"
                                                        @change="toggleManualIntegration" />
                                                    <span class="ml-2">{{ manualIntegrationEnabled ? 'Sim' : 'Não' }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-col>

                        <v-col cols="12">
                            <div class="settings-panel sharepoint-panel">
                                <div class="settings-panel__icon settings-panel__icon--sharepoint">
                                    <v-icon size="34">mdi-microsoft-sharepoint</v-icon>
                                </div>

                                <div class="settings-panel__content">
                                    <div class="settings-panel__eyebrow">
                                        Sharepoint
                                    </div>

                                    <div class="settings-panel__title">
                                        Ligação da pasta da obra
                                    </div>

                                    <div class="settings-panel__subtitle">
                                        Define o link de acesso à pasta Sharepoint associada a esta obra.
                                    </div>

                                    <v-text-field
                                        class="mt-4"
                                        label="Sharepoint"
                                        dense
                                        outlined
                                        v-model="selectedWork.sharepoint_link"
                                    />
                                </div>
                            </div>
                        </v-col>

                        <v-col cols="12" v-if="$store.getters.hasPermission(['super', 'sync.jobs'])">
                            <div class="sync-section">
                                <div class="sync-section__header">
                                    <div>
                                        <div class="sync-section__eyebrow">
                                            Integrações
                                        </div>
                                        <div class="sync-section__title">
                                            Sincronizadores Primavera
                                        </div>
                                        <div class="sync-section__subtitle">
                                            Agenda rapidamente a sincronização dos módulos do projeto.
                                        </div>
                                    </div>
                                </div>

                                <v-row class="mt-2">
                                    <v-col cols="12" md="6">
                                        <v-btn
                                            block
                                            x-large
                                            rounded
                                            class="sync-btn premium-btn premium-btn--mo"
                                            :disabled="!canSync('SYNC-MO')"
                                            @click="syncPrimavera('SYNC-MO')"
                                        >
                                            <v-icon left>mdi-cog-sync-outline</v-icon>
                                            <span class="sync-btn__label">Sincronizar MO</span>
                                        </v-btn>

                                        <div
                                            class="sync-status"
                                            :class="canSync('SYNC-MO') ? 'sync-status--ready' : 'sync-status--disabled'"
                                        >
                                            <v-icon small class="mr-1">
                                                {{ canSync('SYNC-MO') ? 'mdi-check-circle-outline' : 'mdi-clock-outline' }}
                                            </v-icon>
                                            {{ syncStatusText('SYNC-MO') }}
                                        </div>
                                    </v-col>

                                    <v-col cols="12" md="6">
                                        <v-btn
                                            block
                                            x-large
                                            rounded
                                            class="sync-btn premium-btn premium-btn--eq"
                                            :disabled="!canSync('SYNC-EQ')"
                                            @click="syncPrimavera('SYNC-EQ')"
                                        >
                                            <v-icon left>mdi-database-sync-outline</v-icon>
                                            <span class="sync-btn__label">Sincronizar EQ</span>
                                        </v-btn>

                                        <div
                                            class="sync-status"
                                            :class="canSync('SYNC-EQ') ? 'sync-status--ready' : 'sync-status--disabled'"
                                        >
                                            <v-icon small class="mr-1">
                                                {{ canSync('SYNC-EQ') ? 'mdi-check-circle-outline' : 'mdi-clock-outline' }}
                                            </v-icon>
                                            {{ syncStatusText('SYNC-EQ') }}
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="pb-6">
                    <v-row>
                        <v-col cols="12" align="center" justify="center">
                            <v-btn
                                rounded
                                large
                                class="save-btn"
                                @click="addSharepointLink"
                            >
                                <v-icon left>mdi-content-save-outline</v-icon>
                                Gravar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-tab-item>
        </v-tabs-items>

        <DialogSuccess :opened="success.show" @on-ok="success.show = false">
            {{ success.msg }}
        </DialogSuccess>
    </v-card>
</template>

<script>
import User from "@/api/User.js"
//import Teams from "@/api/Teams.js"
import Works from "@/api/Works.js"
import Obra from "@/api/Obra.js"
import IconRemove from '@/components/UI/IconRemove.vue';
import DialogSuccess from '@/components/UI/DialogSuccess.vue';
import Localization from "@/components/Works/local/Localization.vue";

export default {
    name: "AddWorkers",
    props: {
        selectedWork: Object,
    },
    components: {
        IconRemove,
        DialogSuccess,
        Localization
    },
    data() {
        return {
            tabs: 0,
            loading: true,
            manualIntegrationEnabled: false,
            manualIntegrationSaving: false,
            primaveraIntegrationEnabled: false,
            primaveraIntegrationSaving: false,
            primaveraIntegrationLoading: true,
            workers: [],
            selectedWorker: null,
            workersInWork: [],
            success: {
                show: false,
                msg: ''
            },
            teams: [],
            choosenTeam: null
        }
    },
    mounted() {
        this.manualIntegrationEnabled = this.isTruthy(this.selectedWork.allow_manual_integration)
        this.fillBaseData()
        if (this.isSuper) this.loadPrimaveraIntegration()
    },
    methods: {
        isTruthy(value) {
            return value === true || value === 1 || value === '1'
        },

        getJobStatus(type) {
            return type === 'SYNC-MO'
                ? this.selectedWork.last_mo_job_status
                : this.selectedWork.last_eq_job_status
        },

        getLastRunAt(type) {
            return type === 'SYNC-MO'
                ? this.selectedWork.last_mo_job_at
                : this.selectedWork.last_eq_job_at
        },

        getFallbackTodayStart() {
            const now = new Date()
            now.setHours(0, 0, 0, 0)

            return now
        },

        getLastRunDate(type) {
            const lastRunAt = this.getLastRunAt(type)

            if (!lastRunAt) {
                return this.getFallbackTodayStart()
            }

            return new Date(lastRunAt.replace(' ', 'T'))
        },

        getNextAvailableDate(type) {
            const lastRun = this.getLastRunDate(type)

            return new Date(lastRun.getTime() + 30 * 60 * 1000)
        },

        toSqlDateTime(date) {
            const pad = value => String(value).padStart(2, '0')

            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
        },

        canSync(type) {
            const status = this.getJobStatus(type)

            if (status === 'PENDING' || status === 'PROCESSING') {
                return false
            }

            if (status === 'DONE' || status === 'ERROR') {
                const nextAvailable = this.getNextAvailableDate(type)

                return new Date() >= nextAvailable
            }

            return true
        },

        syncStatusText(type) {
            const status = this.getJobStatus(type)
            const lastRun = this.getLastRunDate(type)
            const nextAvailable = this.getNextAvailableDate(type)

            if (status === 'PROCESSING') {
                return 'Atualmente a correr a sincronização'
            }

            if (status === 'PENDING') {
                return `Sincronização agendada às ${this.formatDateTime(lastRun)}. Por favor aguarde.`
            }

            if (status === 'DONE' || status === 'ERROR') {
                if (new Date() < nextAvailable) {
                    return `Última sincronização: ${this.formatDateTime(lastRun)}. Próxima disponível: ${this.formatDateTime(nextAvailable)}`
                }

                return `Última sincronização: ${this.formatDateTime(lastRun)}. Clique agora para voltar a sincronizar`
            }

            return `Última sincronização: ${this.formatDateTime(lastRun)}. Clique agora para voltar a sincronizar`
        },

        formatDateTime(date) {
            return date.toLocaleString('pt-PT', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })
        },

        async loadPrimaveraIntegration() {
            this.primaveraIntegrationLoading = true
            try {
                const response = await Obra.getPrimaveraIntegration(this.selectedWork.Id)
                this.primaveraIntegrationEnabled = this.isTruthy(response.data.is_active)
            } catch (error) {
                console.error(error)
                this.success.msg = 'Não foi possível carregar a configuração Primavera.'
                this.success.show = true
            } finally {
                this.primaveraIntegrationLoading = false
            }
        },

        async togglePrimaveraIntegration(value) {
            if (!this.isSuper) return
            const previous = !value
            this.primaveraIntegrationSaving = true
            try {
                const response = await Obra.updatePrimaveraIntegration(this.selectedWork.Id, { is_active: value })
                this.primaveraIntegrationEnabled = this.isTruthy(response.data.is_active)
                this.success.msg = this.primaveraIntegrationEnabled
                    ? 'Integração da obra para o Primavera ativada.'
                    : 'Integração da obra para o Primavera desativada.'
                this.success.show = true
            } catch (error) {
                console.error(error)
                this.primaveraIntegrationEnabled = previous
                this.success.msg = 'Não foi possível alterar a integração Primavera.'
                this.success.show = true
            } finally {
                this.primaveraIntegrationSaving = false
            }
        },

        async toggleManualIntegration(value) {
            if (!this.canManageManualIntegration) {
                this.manualIntegrationEnabled = this.isTruthy(this.selectedWork.allow_manual_integration)
                return
            }

            this.manualIntegrationSaving = true

            try {
                const resp = await Obra.updateManualIntegration(this.selectedWork.Id, {
                    allow_manual_integration: value
                })

                const newValue = resp.data && resp.data.allow_manual_integration !== undefined
                    ? resp.data.allow_manual_integration
                    : value

                this.manualIntegrationEnabled = this.isTruthy(newValue)
                this.selectedWork.allow_manual_integration = this.manualIntegrationEnabled ? '1' : '0'

                this.success.msg = this.manualIntegrationEnabled
                    ? 'Integração manual via ODC ativada com sucesso.'
                    : 'Integração manual via ODC desativada com sucesso.'

                this.success.show = true

                this.$emit('work-updated', this.selectedWork)
            } catch (e) {
                console.error(e)

                this.manualIntegrationEnabled = this.isTruthy(this.selectedWork.allow_manual_integration)

                this.success.msg = 'Não foi possível alterar a configuração da integração manual.'
                this.success.show = true
            } finally {
                this.manualIntegrationSaving = false
            }
        },

        syncPrimavera(type) {
            this.loading = true

            let payload = {
                work_id: this.selectedWork.Id,
                date: ''
            }

            let params = {
                work_id: this.selectedWork.Id,
                type: type,
                payload: payload
            }

            Works.syncPrimavera(params).then((resp) => {
                const now = new Date()

                this.success.msg = `Foi agendado um job às ${this.formatDateTime(now)}`
                this.success.show = true

                if (type === 'SYNC-EQ') {
                    this.selectedWork.has_eq_job = true
                    this.selectedWork.last_eq_job_at = this.toSqlDateTime(now)
                    this.selectedWork.last_eq_job_status = 'PENDING'
                }

                if (type === 'SYNC-MO') {
                    this.selectedWork.has_mo_job = true
                    this.selectedWork.last_mo_job_at = this.toSqlDateTime(now)
                    this.selectedWork.last_mo_job_status = 'PENDING'
                }

                this.$emit('work-updated', this.selectedWork)
            }).finally(() => {
                this.loading = false
            })
        },

        fillBaseData() {
            this.loadTable();

            User.all().then((resp) => {
                this.workers = resp.data
            })

            /*Teams.all().then((resp) => {
                this.teams = resp.data
            })*/

            this.loading = false
        },

        async loadTable() {
            await Works.getUsers(this.selectedWork.Id).then((resp) => {
                this.workersInWork = resp.data
                this.loading = false
            })
        },

        addUsersToWork() {
            this.loading = true

            let data = {
                work_id: this.selectedWork.Id,
                user_id: this.selectedWorker
            }

            Works.addUser(this.selectedWork.Id, data).then((resp) => {
                this.loadTable();
                this.success.msg = 'Adicionado com sucesso'
                this.success.show = true
                this.loading = false
            })
        },

        addSharepointLink() {
            Works.addSharepointLink(this.selectedWork.Id, this.selectedWork.sharepoint_link).then(() => {
                this.success.msg = 'Sharepoint gravado com sucesso.'
                this.success.show = true
            })
        },

        addUsersFromTeam() {
            this.loading = true

            let data = {
                work_id: this.selectedWork.Id,
                choosen_team: this.choosenTeam
            }

            Works.addUserByTeam(this.selectedWork.Id, data).then((resp) => {
                this.loadTable();
                this.success.msg = 'Adicionado com sucesso'
                this.success.show = true
                this.loading = false
            })
        },

        deleteUser(item) {
            this.loading = true

            let data = {
                work_id: this.selectedWork.Id,
                user_id: item.id
            }

            Works.deleteUser(this.selectedWork.Id, data).then((resp) => {
                this.loadTable();
                this.success.msg = 'Eliminado com sucesso'
                this.success.show = true
            })
        }
    },
    computed: {
        isSuper() {
            return this.$store.getters.hasPermission(['super'])
        },

        canManageManualIntegration() {
            return this.isSuper
        },

        arrayWorkers() {
            let ar = []

            this.workers.forEach(worker => {
                let existe = false

                this.workersInWork.forEach(workerInWork => {
                    if (worker.funcionario_codigo == workerInWork.funcionario_codigo)
                        existe = true
                });

                if (existe == false)
                    ar.push(worker)
            });

            return ar
        }
    },
    watch: {
        selectedWork: {
            deep: true,
            handler(value) {
                if (!value) {
                    return
                }

                this.manualIntegrationEnabled = this.isTruthy(value.allow_manual_integration)
                if (this.isSuper) this.loadPrimaveraIntegration()
            }
        }
    }
}
</script>

<style scoped>
.work-card {
    border-radius: 18px;
    overflow: hidden;
}

.settings-panel {
    display: flex;
    align-items: flex-start;
    gap: 18px;
    border-radius: 22px;
    padding: 24px;
    margin-bottom: 18px;
    border: 1px solid rgba(15, 23, 42, 0.08);
    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

.integration-config-panel {
    background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 45%, #f8fafc 100%);
    border-color: rgba(22, 163, 74, 0.16);
}

.sharepoint-panel {
    background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%);
    border-color: rgba(37, 99, 235, 0.14);
}

.settings-panel__icon {
    width: 58px;
    height: 58px;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #15803d;
    background: rgba(22, 163, 74, 0.12);
    flex: 0 0 auto;
}

.settings-panel__icon--sharepoint {
    color: #1d4ed8;
    background: rgba(37, 99, 235, 0.12);
}

.settings-panel__content {
    flex: 1;
    min-width: 0;
}

.settings-panel__action {
    display: flex;
    align-items: center;
    min-height: 58px;
    flex: 0 0 auto;
}

.settings-panel__eyebrow {
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: #1976d2;
    margin-bottom: 6px;
}

.settings-panel__title {
    font-size: 22px;
    font-weight: 800;
    color: #1e293b;
    line-height: 1.2;
    margin-bottom: 6px;
}

.settings-panel__subtitle {
    font-size: 14px;
    color: #64748b;
    line-height: 1.5;
}

.manual-integration-label {
    font-size: 14px;
    font-weight: 800;
    white-space: nowrap;
}

.manual-integration-label--enabled {
    color: #15803d;
}

.manual-integration-label--disabled {
    color: #64748b;
}

.sync-section {
    background: linear-gradient(135deg, #f8fafc 0%, #eef4ff 100%);
    border: 1px solid rgba(25, 118, 210, 0.10);
    border-radius: 22px;
    padding: 24px;
    box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

.sync-section__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.sync-section__eyebrow {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: #1976d2;
    margin-bottom: 6px;
}

.sync-section__title {
    font-size: 22px;
    font-weight: 700;
    color: #1e293b;
    line-height: 1.2;
    margin-bottom: 4px;
}

.sync-section__subtitle {
    font-size: 14px;
    color: #64748b;
    line-height: 1.5;
}

.sync-btn {
    height: 62px !important;
    font-weight: 700;
    letter-spacing: 0.3px;
    text-transform: none;
    border: none !important;
    box-shadow: 0 14px 28px rgba(15, 23, 42, 0.14);
    transition: all 0.25s ease;
}

.sync-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 18px 34px rgba(15, 23, 42, 0.18);
}

.sync-btn__label {
    font-size: 15px;
}

.premium-btn--mo {
    background: linear-gradient(135deg, #16a34a 0%, #22c55e 100%) !important;
    color: #fff !important;
}

.premium-btn--eq {
    background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%) !important;
    color: #fff !important;
}

.sync-btn.v-btn--disabled {
    box-shadow: none !important;
    transform: none !important;
    background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%) !important;
    color: rgba(255, 255, 255, 0.9) !important;
}

.sync-status {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
    font-size: 13px;
    font-weight: 600;
    min-height: 24px;
}

.sync-status--ready {
    color: #15803d;
}

.sync-status--disabled {
    color: #64748b;
}

.save-btn {
    min-width: 170px;
    height: 48px !important;
    padding: 0 24px !important;
    text-transform: none;
    font-weight: 700;
    letter-spacing: 0.2px;
    color: white !important;
    background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%) !important;
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.28);
}

.save-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 16px 28px rgba(37, 99, 235, 0.34);
}

@media (max-width: 960px) {
    .settings-panel {
        flex-direction: column;
    }

    .settings-panel__action {
        width: 100%;
        justify-content: flex-start;
    }

    .manual-integration-label {
        white-space: normal;
    }
}
</style>